<template>
    <div class="md-layout-item md-medium-size-65 md-small-size-100" style="margin: 0 auto;">
      <div class="team-player">
        <md-card class="md-card-plain" style="margin: 0 0 15px 0">
            <router-link :to="routeLink">
          <h4 class="card-title" style="float: left">
            {{ recipe.title }}
          </h4>
          <div style="float:right">
            <small class="card-description text-muted">
                 {{ new Date(Date.parse(recipe.created)).toLocaleDateString() }}
            </small>
            </div>
            <div style="clear: both; text-align: left">
            <stars :num="recipe.rating" style="float: left"/>
              <small class="card-description text-muted" style="float: right">
                <time-2-make :mins="recipe.timeMins" />
              </small>
              </div>
            </router-link>
        </md-card>
      </div>
      <hr/>
    </div>
</template>

<script>
import Stars from '@/components/Stars.vue';
import Time2Make from '@/components/Time2Make.vue';

export default {
  name: "recipe-list-item",
  components: {
    Stars,
    Time2Make
  },
  props: ["recipe"],
  computed: {
    shortDescription() {
      return this.recipe.description.length > 150
        ? this.recipe.description.slice(0, 147) + "..."
        : this.recipe.description;
    },
    routeLink() {
        return "/recipes/" + this.recipe.id;
    }
  }
};
</script>
